"use client";

import React, { useCallback, useMemo } from "react";

import { useStoredData, useStoredDataDispatch } from "@/store";
import { SupCheckbox } from "@repo/core-ui";

interface GridBarFiltersAtomCheckboxProps {
  filter: string;
  label: string;
  defaultIsChecked?: boolean;
}
export default function GridBarFiltersAtomCheckbox({ filter, label, defaultIsChecked = false }: GridBarFiltersAtomCheckboxProps) {
  const storedData = useStoredData();
  const storedDispatch = useStoredDataDispatch();

  const isChecked = useMemo(
    () => (storedData.filters.find(storedFilter => storedFilter.name === filter)?.values ?? defaultIsChecked) as boolean,
    [defaultIsChecked, filter, storedData.filters]
  );

  const handleCheckboxToggle = useCallback(
    (displayUnauthenticated = false) => {
      if (displayUnauthenticated) {
        storedDispatch({ type: "setFilter", filter: { name: filter, values: true } });
      } else {
        storedDispatch({ type: "clearFilter", filterName: filter });
      }
    },
    [filter, storedDispatch]
  );

  return (
    <div className="flex flex-col">
      <ul className="scrollbar-hidden flex h-[52px] w-full items-center space-x-[8px] overflow-x-scroll">
        <li>
          <SupCheckbox checked={isChecked} label={label} onChange={handleCheckboxToggle} />
        </li>
      </ul>
    </div>
  );
}
